import cn from 'classnames';

import { ButtonGroupContext } from './ButtonGroupContext';
import type { IButtonGroupProps } from './types';
import styles from './buttonGroup.module.scss';

const ButtonGroup = ({ children, variant, size, color, className, dataTest, ariaLabel }: IButtonGroupProps): React.ReactElement => (
  <ButtonGroupContext.Provider value={ { variant, size, color } }>
    <div
      role="group"
      aria-label={ ariaLabel }
      data-test={ dataTest }
      className={ cn(styles.buttonGroup, className) }
    >
      { children }
    </div>
  </ButtonGroupContext.Provider>
);

export default ButtonGroup;
